const typographyModalEquipServQuest = {
  true: 'Nuevo',
  false: 'Editar',
  text: 'Pregunta',
  profileError: 'Espere a que se cargue el archivo'
};

export default typographyModalEquipServQuest;
